import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { ensureNamespaceLoaded } from "../../i18n/lazyNamespaces";
import TeamAgendaRoutes from "../TeamAgenda";

const POPUP_AGENDA_BASE = "/popup-equipe/agenda";

const TeamAgendaPopup = () => {
  useEffect(() => {
    void ensureNamespaceLoaded("teamAgenda");
    void ensureNamespaceLoaded("team");
  }, []);

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        bgcolor: "background.default",
      }}
    >
      <TeamAgendaRoutes basePath="/popup-equipe" standalone />
    </Box>
  );
};

export default TeamAgendaPopup;
